import { log } from 'log';
import { htcmdService } from 'js/services/htcmd.service';
import { storageService } from 'js/services/storage.service';

const rememberMeStorageKey = 'hub2_username_rememberMe';

export const storeRememberMeItem = (userName) => {
    storageService.local.setItem(rememberMeStorageKey, userName);
};

export const retrieveRememberMeItem = () => storageService.local.getItem(rememberMeStorageKey);

export const removeRememberMeItem = () => {
    storageService.local.removeItem(rememberMeStorageKey);
};

/**
 * Get iovation blackbox
 * @private
 * @returns {string}
 */
export const getIovationBlackbox = () => {
    const iovation = window[window.io_global_object_name]?.getBlackbox?.() ?? {};

    return iovation.finished ? iovation.blackbox : null;
};

/**
 * Response may contain userId / username / loginName in different places.
 */
export const parsePasLoginResponse = (pasLoginResponse) => {
    const {
        userId: userIdMaybe,
        loginName: loginNameMaybe,
        username: userNameObj,
        sessionToken: { sessionToken } = {},
        sessionValidationData
    } = pasLoginResponse?.data || {};
    const userName = userNameObj?.username || userNameObj;
    const userId = userNameObj?.userId || userIdMaybe;
    const loginName = userNameObj?.loginName || loginNameMaybe;

    return {
        loginName,
        sessionToken,
        sessionValidationData,
        userId,
        userName
    };
};

export const externalLoginAction = async ({ userId, userName, sessionToken, afterRegisterLogin }) => {
    if (!sessionToken) {
        return;
    }

    if (htcmdService.isEnabled) {
        log('warn', 'NATIVE APP MODE. PREVENT LOGIN TO OPEN API');

        if (afterRegisterLogin) {
            htcmdService.registerNative({ userId, username: userName, sessionToken });
        } else {
            htcmdService.login({ userId, username: userName, sessionToken });
        }

        return Promise.reject({ data: { isPrevented: true } });
    } else if (htcmdService.isWrapperEnabled) {
        if (afterRegisterLogin) {
            htcmdService.registerNative({ userId, username: userName });
        } else {
            htcmdService.login({ userId, username: userName });
        }

        // do not reject here and continue regular login
    }
};
